import { render, staticRenderFns } from "./GeneralH5Activity.vue?vue&type=template&id=22912777&scoped=true"
import script from "./GeneralH5Activity.vue?vue&type=script&lang=js"
export * from "./GeneralH5Activity.vue?vue&type=script&lang=js"
import style0 from "./GeneralH5Activity.vue?vue&type=style&index=0&id=22912777&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22912777",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22912777')) {
      api.createRecord('22912777', component.options)
    } else {
      api.reload('22912777', component.options)
    }
    module.hot.accept("./GeneralH5Activity.vue?vue&type=template&id=22912777&scoped=true", function () {
      api.rerender('22912777', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/GeneralH5Activity.vue"
export default component.exports